import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

const AdministrationRoute = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} md={6} lg={3}>
    <TextField
      label="Route"
      fullWidth
      value={moduleValues?.['Route'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Route']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default AdministrationRoute
